/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import picturefill from 'picturefill';
import objectFitImages from 'object-fit-images';
import Picture from 'components/Picture/Picture';
import Spinner from 'components/Spinner/Spinner';

/**
 * This is the Slide component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Slide({ containerSize, image }) {
  const node = useRef(null);
  const [lodaded, setLoaded] = useState(false);
  const ratio = image.img.height / image.img.width;
  const portrait = ratio > 1;

  useEffect(() => {
    picturefill({
      elements: [node.current],
    });
    objectFitImages(node.current);
  }, []);

  function getStyle() {
    if (containerSize) {
      return {
        width: `${(containerSize.height / ratio / containerSize.width) * 100}%`,
      };
    }

    return {};
  }

  return (
    <div className={classnames('slide', { portrait })}>
      <div style={getStyle()}>
        <div
          style={{ aspectRatio: `${image.img.width} / ${image.img.height}` }}
        >
          <Picture
            ref={node}
            draggable="false"
            {...image}
            onLoad={() => {
              setLoaded(true);
            }}
            onError={() => {
              setLoaded(true);
            }}
          />
          {lodaded ? null : <Spinner />}
        </div>
      </div>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Slide.propTypes = {
  containerSize: PropTypes.object.isRequired,
  image: PropTypes.shape({
    img: PropTypes.object.isRequired,
  }).isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Slide.defaultProps = {
  containerSize: {},
  image: {
    img: {},
  },
};

export default Slide;
